import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { EditRankingStrategyContainer } from './EditRankingStrategyContainer';
import { CollapseDrawer } from '../CollapseDrawer/CollapseDrawer';
import { useNavigateToVisualEditorRoute } from '../../hooks/useNavigateToVisualEditorRoute';
import { visualEditorActions } from '../../state';
import { PermittedRouteMap } from '../../../../app-routes';
import { ShopFeatureToggles } from '../../../../services/src/service/types/shops';

interface Props {
  shopId: number;
  permittedRouteMap: PermittedRouteMap;
  className: string;
  featureToggles: ShopFeatureToggles;
}

export const EditRankingStrategy = ({
  shopId,
  permittedRouteMap,
  className,
  featureToggles,
}: Props): JSX.Element | null => {
  const appDispatch = useDispatch();
  const { navigateToVisualEditorRoute } = useNavigateToVisualEditorRoute({
    route: permittedRouteMap?.visualEditor,
  });

  const closeRankingStrategyDrawer = useCallback(() => {
    appDispatch(visualEditorActions.notifyIsDirty({ isDirty: false }));
    navigateToVisualEditorRoute({ shopId });
  }, [appDispatch, navigateToVisualEditorRoute, shopId]);

  return (
    <CollapseDrawer
      open
      className={className}
      onClose={() => navigateToVisualEditorRoute({ shopId })}
    >
      <EditRankingStrategyContainer
        shopId={shopId}
        dispatch={appDispatch}
        closeRankingStrategyDrawer={closeRankingStrategyDrawer}
        featureToggles={featureToggles}
      />
    </CollapseDrawer>
  );
};
